const { adminCall } = require("./_utils");

module.exports = {
  create: data => adminCall("group.create", data),
  modify: data => adminCall("group.modify", data),
  remove: uid => adminCall("group.remove", {uid}),
  getInfo: uid => adminCall("group.info", {uid})
}
